import React from 'react';
import Heading from '../../components/atoms/Heading';

const NotFound = () => {
    return (
        <div className='h-screen w-screen flex justify-center items-center'>
                <div className='w-auto h-full flex flex-col justify-center items-center space-y-6'>
                    <Heading color='red' text='404 - Página no encontrada'/>
                    <p>La página que buscas no existe. Tal vez quieras regresar al inicio.</p>
                    <a href="/" className='text-[#e73842] text-base'>Volver al inicio</a>
                </div>
        </div>
    );
};

export default NotFound;